import { Contact, Property } from '../../types/property';

const AWARDS_TEXT: { [key: string]: string } = {
  ppAwardsDevWinner22: 'Award Winning Development',
  ppAwardsDevHighlyCommended22: 'Highly Commended Development',
  ppAwardsWinner22: 'Award Winning Developer',
  ppAwardsHighlyCommended22: 'Highly Commended Developer',
};

export const getAward = (property: Property) => {
  if (property.agents && property.agents.length > 1) {
    return null;
  }

  return property.account.propertypalAwards?.length ? property.account.propertypalAwards[0] : null;
};

export const getAwardFromContact = (contact?: Contact) => {
  return contact?.propertypalAwards?.length ? contact.propertypalAwards[0] : null;
};

export const getDevelopmentAward = (property: Property) => {
  if (property.type === 'development' || property.development) {
    if (property.propertypalAwards?.length) {
      const [award] = property.propertypalAwards;

      return {
        text: AWARDS_TEXT[award.textKey],
        imageUrl: award.imageUrl,
        url: award.url,
      };
    }

    if (property.account.propertypalAwards?.length) {
      const [award] = property.account.propertypalAwards;

      if (award.textKey === 'ppAwardsWinner22' || award.textKey === 'ppAwardsHighlyCommended22') {
        return {
          text: AWARDS_TEXT[award.textKey],
          imageUrl: award.imageUrl,
          url: award.url,
        };
      }
    }
  }

  return null;
};
